export default __webpack_public_path__ + "static/media/mTop_3_c2.b701d2e4.jpeg";